<template>
    <div id="modal-enter-detail-menu" class="modal fade show">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item border-0" @click="openPrivateInfo">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-user icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2"> 個人情報 </span>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item border-0" @click="openResume">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-external-link-alt icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2"> 履歴書 </span>
                                </div>
                            </div>
                        </li>
                        <li v-if="item.in_flg != 'y'" class="list-group-item border-0" @click="openContractPeriod">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-clipboard icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2"> 契約期間 </span>
                                </div>
                            </div>
                        </li>
                        <li v-if="item.in_flg != '6' && item.in_flg != 'y'" class="list-group-item border-0" @click="openEnterConfirm">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-handshake icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2"> 入場確定 </span>
                                </div>
                            </div>
                        </li>
                        <li v-if="item.in_flg != '6'" class="list-group-item border-0" @click="cancelEnter">
                            <div class="row">
                                <div class="col-2 pr-0 text-center">
                                    <i class="text-muted fas fa-comments-dollar icon-size"></i>
                                </div>
                                <div class="col pl-2">
                                    <span class="pl-2">
                                        入場取消 
                                        <span v-if="item.in_flg == 'y'" class="text-danger">(取消済み)</span>
                                        <span v-else class="text-success">(入場待ち)</span>
                                    </span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from 'js/event-bus'
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                item: {}
            }
        },
        mounted () {
            this.menuBusOn()
        },
        methods: {
            menuBusOn () {
                EventBus.$on('enterDetailMenu', (item) => {
                    this.item = item
                    this.openThis()
                })
            },
            openThis () {
                $('#modal-enter-detail-menu').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-enter-detail-menu').modal('hide')
            },
            resetThis () {
                this.item = {}
            },
            openPrivateInfo () {
                this.$parent.openPrivateInfo(this.item.user_id)
                this.hideThis()
            },
            openResume () {
                window.open(this.item.resume, "_blank")
                this.hideThis()
            },
            openContractPeriod () {
                this.$parent.openContractPeriod(this.item)
                this.hideThis()
            },
            openEnterConfirm () {
                let lev = 2
                let msg = "入場を確定しますか？"
                let msgKey = "enterConfirm"
                this.$parent.openMsg(lev, msg, msgKey, this.item)
                this.hideThis()
            },
            cancelEnter () {
                this.$parent.cancelEnter(this.item)
                this.hideThis()
            }
        }
    }
</script>

<style>

</style>
